import { useMutation } from 'react-query';
import {
  checkDuplicateSnsAccount,
  type CheckDuplicateSnsAccountBody,
  type CheckDuplicateSnsAccountResponse
} from '../../../findBuddy/services/findBuddyService';

export function useCheckDuplicateSnsAccount() {
  return useMutation<CheckDuplicateSnsAccountResponse, Error, CheckDuplicateSnsAccountBody>(
    (body) => checkDuplicateSnsAccount(body)
  );
}
